import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';


interface iProgramas{
		ID?: number, // Identificador
		Tipo_Nivel_ID?: number, // "Programa" , "Modalidad" , "Submodalidad"
		Padre_ID?: number, // Padre Id
		Nombre?: string, // Identificador
		Nombre_Comercial?: string,
		Objetivo?: string,
		Descripcion?: string,
		Imagen?: string,
		Estatus?: boolean,
		Derechos?: string,
		Obligaciones?: string,
		Restricciones?: string,
		Procedimiento?: string,
		Presupuesto_ID?: number,
		Tipo_Programa_ID?: number,
		Requiere_Cita?: boolean,
		Renovacion?: boolean,
		Renovacion_Perfil?: string,
		Monto_Asignado?: number,
		Monto_Max_Anual?: number,
		Monto_Max?: number,
		Vigente?:boolean
}
@Injectable({
	providedIn: 'root'
})
export class ProgramasService {

	constructor(private http:HttpClient) { }
	mostrarProgramas(ID?){
		let cadena = environment.ip + '/programa/Obtener'
		if (ID === undefined){
			return this.http.get<any>(cadena + '/6/20')
		} else {
			return this.http.get<any>( `${cadena}/${ID}`)
		}
	}
	//  mostrarProgramas(ID){
	//    return this.http.get<any>(`${environment.ip}/API/programa/Obtener/${ID}`)
	//  }
	crearPrograma(Data){
		return this.http.post<any>(environment.ip + '/programa/Crear',Data)
	}
	actualizarPrograma(Data){
		return this.http.put<any>(environment.ip + '/programa',Data)
	}
	crearModalidad(Data){
		return this.http.post<any>(environment.ip + '/programa/Modalidad/Crear',Data)
	}
	crearSubModalidad(Data){
		return this.http.post<any>(environment.ip + '/programa/Submodalidad/Crear',Data)
	}
	ActualizarEstatusPrograma (ID) {
		return this.http.get<any>(`${environment.ip}/programa/ActualizarEstatus/${ID}`,)
	}
	listarPrograma(pagina, registros) {
		const paginador = {
			NumeroPagina: pagina,
			NumeroRegistros: registros
		};
		return this.http.post<any>(`${environment.ip}/programa/Listar`, paginador)
	}
	listarTiposNivel () {
		return this.http.get<any>(`${environment.ip}/programa/TiposNivel`)
	}
	listarTiposPrograma () {
		return this.http.get<any>(`${environment.ip}/programa/TiposPrograma`)
	}
	listarTiposApoyo () {
		return this.http.get<any>(`${environment.ip}/programa/TiposApoyo`)
	}
	listarTiposDocumentos () {
		return this.http.get<any>(`${environment.ip}/programa/TiposDocumento`)
	}
	listarPresupuestos (ID) {
		return this.http.get<any>(`${environment.ip}/programa/Presupuestos/` + ID)
	}
	mostrarModalidad(ID){
		let cadena = environment.ip + '/programa/Modalidad/Obtener'
		if (ID === undefined){
			return this.http.get<any>(cadena + '/6/20')
		} else {
			return this.http.get<any>( `${cadena}/${ID}`)
		}
	}
	listarModaliad (pagina, registros) {
		const paginador = {
			NumeroPagina: pagina,
			NumeroRegistros: registros
		};
		return this.http.post<any>(`${environment.ip}/programa/Molidalidad/Listar`,paginador)
	}

	mostrarSubModalidad(ID){
		let cadena = environment.ip + '/programa/SubModalidad/Obtener'
		if (ID === undefined){
			return this.http.get<any>(cadena + '/6/20')
		} else {
			return this.http.get<any>( `${cadena}/${ID}`)
		}
	}
	listarSubModaliad (pagina,registros) {
		const paginador = {
			NumeroPagina: pagina,
			NumeroRegistros: registros
		};
		return this.http.post<any>(`${environment.ip}/programa/SubModalidad/Listar`, paginador)
	}
	obtenerPMS(ID) {
		return this.http.get<any>(`${environment.ip}/programa/ObtenerPMS/` + ID)
	}

	listarDocumentosPorPrograma(idPrograma){
		return this.http.get<any>(`${environment.ip}/Programa/TiposDocumentoPrograma/${idPrograma}`);
	}
}
